import React from "react";

const UsersListLoading = () => {
    const styles = {
        borderRadius: '0.475rem',
        boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
        backgroundColor: '#fff',
        color: '#7e8299',
        fontWeight: '500',
        margin: '0',
        width: 'auto',
        padding: '1rem 2rem',
        top: 'calc(50% - 2rem)',
        left: 'calc(50% - 4rem)',
        zIndex: 5000000
    }

    return <div className={'d-flex align-items-center'} style={{...styles, position: 'fixed', textAlign: 'center'}}><span className="spinner-border spinner-border-lg align-middle"></span></div>
}

export {UsersListLoading}
